import Checkboxes from 'components/Formik/Checkboxes';

const TopicsOfInterestHCP = ({ initialValues, data }) => {
	initialValues.Topics_Of_Interest__c = [];
	const { label, options } = data;
	return (
		<div>
			<p>
				<strong>{label}</strong>
			</p>
			<Checkboxes options={options} label='Topics_Of_Interest__c' name='Topics_Of_Interest__c' />
		</div>
	);
};

export default TopicsOfInterestHCP;
